import type { AuthUser } from '~/types/auth/auth';
import { pbRequest, pbRequestVoid } from '~/services/request';

/**
 * How long a sign-out waits for the API to end the sessions, per attempt, before it signs out of
 * this browser alone. Long enough for a cold start of the API's Lambda; short of the 30 s any other
 * request may take, because the member is waiting to be signed out.
 */
export const REVOKE_TOKENS_TIMEOUT_MS = 10_000;

// Pure API service - no state management
export const authService = {
    async getMe(): Promise<AuthUser> {
        const nuxtApp = useNuxtApp();

        return await pbRequest<AuthUser>(nuxtApp.$api.routes.me.getMe(), {
            failure: 'Error while fetching user info',
        });
    },

    /** End every sign-in session of the member, on every device (`DELETE /v3/me/tokens`). */
    async revokeTokens(): Promise<void> {
        const nuxtApp = useNuxtApp();

        await pbRequestVoid(nuxtApp.$api.routes.me.revokeTokens(), {
            method: 'DELETE',
            timeout: REVOKE_TOKENS_TIMEOUT_MS,
            failure: 'Error while ending the sign-in sessions',
        });
    },

    /** Delete the member's account and everything in it (`DELETE /v3/me`), which answers 204. */
    async deleteAccount(): Promise<void> {
        const nuxtApp = useNuxtApp();

        await pbRequestVoid(nuxtApp.$api.routes.me.deleteAccount(), {
            method: 'DELETE',
            expect: 204,
            failure: 'Error while deleting the account',
        });
    },
};
